import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OpfoelgningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { OpfoelgningDialogData, OpfoelgningDialogResponse } from 'src/app/components/aftale/models';
import { OpfoelgningChanged, SignalrService } from 'src/app/services/signalr.service';
import { OpfoelgningDialogComponent } from '../../components/opfoelgning-dialog/opfoelgning-dialog.component';
import { AuthService } from '../../../services/auth.service';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { OpfoelgningService } from 'src/app/api/services';
import { OpfoelgningerService } from 'src/app/services/opfoelgninger.service';

@Component({
  selector: 'app-opfoelgning-action',
  templateUrl: './opfoelgning-action.component.html',
  styleUrls: ['./opfoelgning-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OpfoelgningActionComponent implements OnInit {
  canWrite: boolean = false;

  unsubscribe$ = new Subject<void>();

  @Input() opfoelgningList: OpfoelgningDto[];
  @Input('offset-class') offsetclass: string = 'opfoelgning-bookmark-count__action';
  @Input() opfoelgning: OpfoelgningDto;
  @Input() serviceordre?: ServiceordreDto;
  @Input() serviceaftale?: ServiceaftaleDto;
  @Input() entityNo: number;

  @Output() opfoelgningChange: EventEmitter<OpfoelgningDialogResponse> = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    private signalR: SignalrService,
    private auth: AuthService,
    private opfoelgningerService: OpfoelgningerService,
  ) {
    this.canWrite = this.auth.canWrite;
  }

  ngOnInit(): void {
    this.signalR.opfoelgningChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((event: OpfoelgningChanged) => {
      if (this.entityNo == event.entityNo) {
        let updated = this.opfoelgningList.findIndex((p) => p.id == event.opfoelgning.id);
        if (updated >= 0) this.opfoelgningList.splice(updated, 1, event.opfoelgning);
        else this.opfoelgningList.push(event.opfoelgning);
      }
    });
  }

  opfoelgninger(): string {
    return this.useropfolgninger()
      .map((o) => o.note)
      .join('\n');
  }

  useropfolgninger(): Array<OpfoelgningDto> {
    return this.opfoelgningList.filter((p) => p.user == this.auth.username);
  }

  button() {
    return this.opfoelgningerService.opfoelgningState(this.opfoelgningList, this.auth.username);
  }

  doOpfoelgning(event: Event) {
    event.stopPropagation();

    const data: OpfoelgningDialogData = {
      opfoelgninger: this.opfoelgningList,
      entityNo: this.entityNo,
      serviceordre: this.serviceordre,
      okKundeAftaleNr: this.serviceaftale?.okKundeAftaleNr,
    };
    let dialogRef = this.dialog.open(OpfoelgningDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data,
    });

    dialogRef.afterClosed().subscribe((response: OpfoelgningDialogResponse) => {
      if (response) {
        this.opfoelgningChange.emit(response);
      }
    });
  }

  getToolTip(text: string) {
    const users = this.opfoelgningerService.otherUsers(this.opfoelgningList, this.auth.username);
    return text.replace('{users}', users);
  }
}
